import 'reflect-metadata';
import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import { injectable } from 'inversify-props';
import { inject } from 'inversify';
import { ILogger } from './LoggerService';

export interface IHttpClient {

	/** Performs a GET request to the specified url */
	get<T>(url: string, options?: AxiosRequestConfig): Promise<T>;

	/** Performs a POST request to the specified url */
	post<T>(url: string, payload: any): Promise<T>;

	/** Performs a PUT request to the specified url */
	put<T>(url: string, payload: any): Promise<T>;

	/** Performs a DELETE request to the specified url */
	delete(url: string, payload?: any): Promise<any>;

	/** Adds the authentication headers to all requests going forward */
	addAuthHeaders(token: string);

}


@injectable()
export class HttpClientService implements IHttpClient {

	protected client!: AxiosInstance;

	constructor(
		@inject('ILogger') private logger: ILogger) {
		this.client = axios.create();
	}

	/** Performs a GET request to the specified url */
	public async get<T>(url: string, options?: AxiosRequestConfig): Promise<T> {
		const request: AxiosRequestConfig = {
			url,
			method: 'GET',
		};
		if (options && options.cancelToken) {
			request.cancelToken = options.cancelToken;
		}
		return this.client.request<T>(request).then((response: AxiosResponse) => {
			return response.data;
		});
	}

	/** Performs a POST request to the specified url */
	public async post<T>(url: string, payload: any): Promise<T> {
		return this.client.post<T>(url, payload).then((response: AxiosResponse) => {
			return response.data;
		});
	}

	/** Performs a PUT request to the specified url */
	public async put<T>(url: string, payload: any): Promise<T> {
		return this.client.put<T>(url, payload).then((response: AxiosResponse) => {
			return response.data;
		});
	}

	/** Performs a DELETE request to the specified url */
	public async delete(url: string, payload?: any): Promise<any> {
		return this.client.delete(url, { data: payload }).then((response: AxiosResponse) => {
			return response.data;
		});
	}

	/** Adds the authentication headers to all requests going forward */
	public addAuthHeaders(token: string): void {
		this.client.defaults.headers.common.Authorization = `Bearer ${token}`;
	}

}
